import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Stack, Typography } from '@mui/material';
import { AttachmentViewerModal, DataGrid, FileTypeEnum } from '@orijinworks/frontend-commons';
import { useFormSubmissionsHook } from './useFormSubmissionsHook';
import { pageHeadingFromFormTitle } from './utils/form-submission.util';
import { NavyMainTypography } from '../modules/Feeds/Feeds.style';

/** Lists `FormResponse` rows for a form (`data` JSON columns are dynamic per form). */
const FormSubmissions = React.memo(() => {
  const {
    formTitle,
    columns,
    gridData,
    tdStyles,
    tableSx,
    pageSize,
    loading,
    refreshSubmissions,
    handleBackToForms,
    primaryButtonProps,
    secondaryButtonProps,
    previewForm,
    clearPreviewForm,
  } = useFormSubmissionsHook();

  const headingTitle = pageHeadingFromFormTitle(formTitle);

  return (
    <Stack
      height="100%"
      backgroundColor="white"
      direction="column"
      spacing={2}
      padding="20px"
    >
      {previewForm != null && (
        <AttachmentViewerModal
          fileName={previewForm.name ?? 'Form'}
          fileType={FileTypeEnum.OTHER}
          formReadOnly
          formSchema={previewForm.schema ?? undefined}
          open
          onClose={clearPreviewForm}
        />
      )}
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={2}>
        <Stack direction="row" spacing={2} alignItems="flex-start" flex={1} minWidth={0}>
          <IconButton
            aria-label="Back to forms"
            color="primary"
            onClick={handleBackToForms}
            sx={{
              border: '1px solid',
              borderColor: 'primary.main',
              flexShrink: 0,
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Stack spacing={0.5} minWidth={0}>
            <NavyMainTypography variant="h1">{headingTitle}</NavyMainTypography>
            <Typography variant="body2" color="text.secondary">
              Form Submissions
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <DataGrid
        columns={columns}
        data={[...gridData]}
        pageSize={pageSize}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationMode="client"
        isLoading={loading}
        isAllSelected={false}
        showSelection={false}
        onSelectionChange={() => {}}
        onRefreshHandler={refreshSubmissions}
        hasActionColumn={true}
        primaryButtonProps={primaryButtonProps}
        secondaryButtonProps={secondaryButtonProps}
        tableSx={tableSx}
        tdStyles={tdStyles}
      />
    </Stack>
  );
});

export default FormSubmissions;
